export enum DataTestId {
    CurrencySelectDialogSelectionCard = 'currency-select-dialog-selection-card',
}
